import { createSlice } from "@reduxjs/toolkit";

const cartList = createSlice({
  name: "cartList",
  initialState: [],
  reducers: {
    saveCartList: (state, action) => {
      return action.payload;
    },
  },
});

export const { saveCartList } = cartList.actions;
export default cartList.reducer;
